<div class="table-actions">
    <button (click)="moreActionsPopover.toggle($event)">
        <svg width="16" height="16">
            <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#ellipsis'"></use>
        </svg>
    </button>
    <ntv-popover #moreActionsPopover placement="bottom-end" [offset]="10">
        <div class="actions-container">
            @for (action of actions(); track action.name) {
                <div
                    class="action-item"
                    [attr.name]="action.name"
                    (click)="moreActionsPopover.toggle($event); handleTableAction(action.name)">
                    <svg
                        class="icon icon--hoverable"
                        [style.color]="action.color"
                        width="14"
                        height="14">
                        <use
                            [attr.xlink:href]="
                                'assets/icons/icons-sprite.svg#' + action.icon
                            "></use>
                    </svg>

                    <p
                        [ngStyle]="{
                            color: action.hightlighLabel ? action.color : '',
                        }">
                        {{ action.name }}
                    </p>
                </div>
            }
        </div>
    </ntv-popover>
</div>
